var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownstreamDisposalH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 682.667,
    height: 682.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-203.147c-5.523 0-9.999 4.477-9.999 10v102.124l111.573 32 111.572-32V9.999C9.999 4.477 5.522 0 0 0",
    style: {
      fill: "#5392f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(247.11 21.927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-109.869c0-5.524-4.478-9.999-10-9.999h27.001c5.522 0 9.999 4.476 9.999 9.999V-7.744Z",
    style: {
      fill: "#4071f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(230.108 141.795)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h49.388a6.788 6.788 0 0 0 6.19-4.002l9.976-22.144a6.786 6.786 0 0 1 6.19-4.001h85.402c3.882 0 6.578 3.867 5.235 7.509l-21.859 59.273a10.5 10.5 0 0 1-9.853 6.868h-211.95c-4.4 0-8.332-2.742-9.854-6.869l-21.858-59.273c-1.344-3.642 1.351-7.508 5.234-7.508h85.402a6.789 6.789 0 0 1 6.191 4.001L-6.19-4.002A6.787 6.787 0 0 0 0 0",
    style: {
      fill: "#91dafa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(120.843 138.257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-21.858 59.272a10.502 10.502 0 0 1-9.854 6.869h-27c4.399 0 8.332-2.741 9.854-6.868L-27 .002c1.343-3.643-1.353-7.512-5.234-7.512h27C-1.352-7.51 1.344-3.643 0 0",
    style: {
      fill: "#6cbff8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(283.224 115.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-243.936c-5.522 0-10 4.478-10 10v240.525c0 5.524 4.478 10.001 10 10.001H0c5.522 0 10-4.476 10-10V10.001C10 4.478 5.522 0 0 0",
    style: {
      fill: "#e9a52d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(494.5 229.547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-25.677c6.221 0 11.264-5.041 11.264-11.263V-249.26c0-6.221-5.043-11.266-11.264-11.266H0c5.522 0 10 4.477 10 10.001V-10C10-4.477 5.522 0 0 0",
    style: {
      fill: "#e38523",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(494.5 490.073)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-44.876c0-4.11 4.684-6.465 7.982-4.013l18.074 13.435a5 5 0 0 0 5.965 0l18.073-13.435c3.299-2.452 7.982-.097 7.982 4.013V0Z",
    style: {
      fill: "#f7f3f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(343.494 490.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-40.523 52.979c-2.287 2.99-6.79 2.99-9.076 0L-90.122 0c-2.875-3.759-.195-9.184 4.537-9.184h17.023a5 5 0 0 0 5-5v-37.515c0-6.036-4.893-10.93-10.929-10.93h-44.672a5 5 0 0 1-5-5v-27a5 5 0 0 1 5-5h44.672c26.47 0 47.929 21.459 47.929 47.93v37.515a5 5 0 0 0 5 5h17.024C.194-9.184 2.875-3.759 0 0",
    style: {
      fill: "#6dc17d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(439.175 143.003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48.274 30.212a4.998 4.998 0 0 1-5.305 0L-101.853 0a5 5 0 0 0-6.667 1.257l-9.934 13.376a5 5 0 0 0 1.361 7.22l58.208 36.429a14.999 14.999 0 0 0 15.916 0L15.24 21.853a5 5 0 0 0 1.362-7.22L6.667 1.257A5 5 0 0 0 0 0",
    style: {
      fill: "#6dc17d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(173.384 229.787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48.274 30.212a4.998 4.998 0 0 1-5.305 0L-101.853 0a5 5 0 0 0-6.667 1.257l-9.934 13.376a5 5 0 0 0 1.361 7.22l58.208 36.429a14.999 14.999 0 0 0 15.916 0L15.24 21.853a5 5 0 0 0 1.362-7.22L6.667 1.257A5 5 0 0 0 0 0",
    style: {
      fill: "#6dc17d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(173.384 302.183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48.274 30.213a5.002 5.002 0 0 1-5.305 0L-101.853 0a5 5 0 0 0-6.667 1.257l-9.934 13.376a5 5 0 0 0 1.361 7.22l58.208 36.43a14.999 14.999 0 0 0 15.916 0l58.209-36.43a5 5 0 0 0 1.362-7.22L6.667 1.257A5 5 0 0 0 0 0",
    style: {
      fill: "#6dc17d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(173.384 374.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-76.183c0-5.529-4.479-9.999-9.999-9.999h-203.147a9.996 9.996 0 0 0-9.999 10v14.881",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(257.108 108.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v26.301",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(33.96 81.808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h49.388a6.788 6.788 0 0 0 6.19-4.002l9.976-22.144a6.786 6.786 0 0 1 6.19-4.001h85.402c3.882 0 6.578 3.867 5.235 7.509l-21.859 59.273a10.5 10.5 0 0 1-9.853 6.868h-211.95c-4.4 0-8.332-2.742-9.854-6.869l-21.858-59.273c-1.344-3.642 1.351-7.508 5.234-7.508h85.402a6.789 6.789 0 0 1 6.191 4.001L-6.19-4.002A6.787 6.787 0 0 0 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(120.843 138.257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-44.876c0-4.11 4.684-6.465 7.982-4.013l18.074 13.435a5 5 0 0 0 5.965 0l18.073-13.435c3.299-2.452 7.982-.097 7.982 4.013V0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(343.494 490.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.438 23.275c-3.808 6.596-13.329 6.596-17.137 0l-28.941-50.126",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(394.54 376.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-22.24-5.25a1.866 1.866 0 0 0-2.217 1.28l-6.572 21.885",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(358.626 354.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.438-23.275c-3.808-6.596.953-14.841 8.569-14.841h57.881",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(318.823 321.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 15.667-16.635a1.864 1.864 0 0 0 0-2.56L0-35.83",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(355.66 301.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26.876c7.616 0 12.377 8.245 8.568 14.841L6.505 64.967",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(404.234 283.274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.572 21.886c.143.472.456.849.856 1.079.398.23.882.314 1.362.2l22.239-5.25",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(403.312 325.276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-177.978c0-5.523-4.478-10.001-10-10.001h-243.936c-5.522 0-10 4.478-10 10V62.547c0 5.523 4.478 10.001 10 10.001H-10c5.522 0 10-4.477 10-10V35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(504.5 417.525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-40.523 52.979c-2.287 2.99-6.79 2.99-9.076 0L-90.122 0c-2.875-3.759-.195-9.184 4.537-9.184h17.023a5 5 0 0 0 5-5v-37.515c0-6.036-4.893-10.93-10.929-10.93h-44.672a5 5 0 0 1-5-5v-27a5 5 0 0 1 5-5h44.672c26.47 0 47.929 21.459 47.929 47.93v37.515a5 5 0 0 0 5 5h17.024C.194-9.184 2.875-3.759 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(439.175 143.003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48.274 30.212a4.998 4.998 0 0 1-5.305 0L-101.853 0a5 5 0 0 0-6.667 1.257l-9.934 13.376a5 5 0 0 0 1.361 7.22l58.208 36.429a14.999 14.999 0 0 0 15.916 0L15.24 21.853a5 5 0 0 0 1.362-7.22L6.667 1.257A5 5 0 0 0 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(173.384 229.787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48.274 30.212a4.998 4.998 0 0 1-5.305 0L-101.853 0a5 5 0 0 0-6.667 1.257l-9.934 13.376a5 5 0 0 0 1.361 7.22l58.208 36.429a14.999 14.999 0 0 0 15.916 0L15.24 21.853a5 5 0 0 0 1.362-7.22L6.667 1.257A5 5 0 0 0 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(173.384 302.183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-48.274 30.213a5.002 5.002 0 0 1-5.305 0L-101.853 0a5 5 0 0 0-6.667 1.257l-9.934 13.376a5 5 0 0 0 1.361 7.22l58.208 36.43a14.999 14.999 0 0 0 15.916 0l58.209-36.43a5 5 0 0 0 1.362-7.22L6.667 1.257A5 5 0 0 0 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(173.384 374.578)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownstreamDisposalH);
export default __webpack_public_path__ + "static/media/DownstreamDisposal-h.9343e638bb262c4a7315adfdcb36d894.svg";
export { ForwardRef as ReactComponent };